import { PropertyDefinition, PropertyDefinitionOneOf, PropertyDefinitonMapping, PropertyMappingType, } from "app/library/layout-builder";
import {
    CardListSizesDefault,
    ColumnSizesOneOf,
    ImageSizesOneOf,
    ReorderingOneOf,
    SlideshowArrows,
    SlideshowLazyload,
} from "./defaults";

export function getMenuDefinitions(key: string, text: string) {
    return [
        {
            name: key,
            text,
            description: "İlgili Menü'yü Seçiniz",
            mapping: {
                type: PropertyMappingType.Menu,
            },
            group: {
                key,
                title: `${text} Ayarları`,
                withObject: false,
            },
        },
        {
            name: "level",
            text: `${text} Derinliği`,
            description: "Menü'nün Gözükecek Alt Menü Derinliği",
            mapping: {
                type: PropertyMappingType.Object,
                oneOf: [
                    {
                        key: 0,
                        text: "Alt Menüleri Gizle",
                    },
                    {
                        key: 1,
                        text: "1. Derece",
                    },
                    {
                        key: 2,
                        text: "2. Derece",
                    },
                    {
                        key: 3,
                        text: "3. Derece",
                    },
                    {
                        key: 4,
                        text: "4. Derece",
                    },
                    {
                        key: 5,
                        text: "5. Derece",
                    },
                ],
            },
            group: {
                key,
                title: `${text} Ayarları`,
                withObject: true,
            },
        },
    ];
}

export const PureMenuDefinitions: PropertyDefinition[] = [
    {
        name: "id",
        text: "Menü",
        description: "İlgili Menü'yü Seçiniz",
        mapping: {
            type: PropertyMappingType.Menu,
        },
    },
    {
        name: "level",
        text: "Menü Derinliği",
        description: "Menü'nün Gözükecek Alt Menü Derinliği",
        default: 2,
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: [
                {
                    key: 0,
                    text: "Alt Menüleri Gizle",
                },
                {
                    key: 1,
                    text: "1. Derece",
                },
                {
                    key: 2,
                    text: "2. Derece",
                },
                {
                    key: 3,
                    text: "3. Derece",
                },
                {
                    key: 4,
                    text: "4. Derece",
                },
                {
                    key: 5,
                    text: "5. Derece",
                },
            ],
        },
    },
];

export const NavigationItemDefinitions: PropertyDefinition[] = [
    {
        name: "title",
        text: "Başlık",
        mapping: {
            type: PropertyMappingType.String
        }
    },
    {
        name: "anchor",
        text: "URL",
        mapping: {
            type: PropertyMappingType.LinkWizard,
        }
    },
];

export const PostGalleryDefinitions: PropertyDefinition[] = [
    {
        name: "title",
        text: "Başlık",
        mapping: {
            type: PropertyMappingType.String
        }
    },
    {
        name: "type",
        text: "Dosya Tipi",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: [
                {
                    key: "image",
                    text: "Görsel"
                },
                {
                    key: "video",
                    text: "Video"
                }
            ],
        },
        default: "image"
    },
    {
        name: "src",
        text: "Dosya (Video - Fotoğraf)",
        mapping: {
            type: PropertyMappingType.File
        }
    }
]

export const ImageChildrenDefinitions: PropertyDefinition[] = [
    {
        name: "src",
        mapping: {
            type: PropertyMappingType.Image,
        },
        text: "Görsel Seçin",
    },
    {
        name: "alt",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Görsel Alt Etiketi",
    },
    {
        name: "width",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Görsel Genişlik",
    },
    {
        name: "height",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Görsel Yükseklik",
    },
    {
        name: "srcset",
        mapping: {
            type: PropertyMappingType.SrcSet,
        },
        text: "Responsive Görseller",
    },
    {
        name: "lazyload",
        mapping: {
            type: PropertyMappingType.Boolean,
        },
        text: "Görseli Görüntülendiğinde Yükle (Lazy Load)",
        default: true,
    },
];
export const VideoChildrenDefinitions: PropertyDefinition[] = [
    {
        name: "src",
        mapping: {
            type: PropertyMappingType.Video,
        },
        text: "Video Seçin",
    },
    {
        name: "alt",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Video Alt Etiketi",
    },
    {
        name: "width",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Video Genişlik",
    },
    {
        name: "height",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Video Yükseklik",
    },
    {
        name: "lazyload",
        mapping: {
            type: PropertyMappingType.Boolean,
        },
        text: "Videoyı Görüntülendiğinde Yükle (Lazy Load)",
        default: true,
    },
];


export const CardColumnSizeOneOf: PropertyDefinitionOneOf[] = [
    {
        key: "",
        text: "Varsayılan",
    }, {
        key: 1,
        text: "1",
    },
    {
        key: 2,
        text: "2",
    },
    {
        key: 3,
        text: "3",
    },
    {
        key: 4,
        text: "4",
    },
    {
        key: 5,
        text: "5",
    },
    {
        key: 6,
        text: "6",
    },
    {
        key: 7,
        text: "7",
    },
    {
        key: 8,
        text: "8",
    },
    {
        key: 9,
        text: "9",
    },
    {
        key: 10,
        text: "10",
    },
    {
        key: "11",
        text: "11",
    },
    {
        key: 12,
        text: "12",
    },
];

export const ResponsiveMapping: PropertyDefinitonMapping = {
    type: PropertyMappingType.ArrayData,
    keys: [{
        name: "breakpoint",
        mapping: {
            type: PropertyMappingType.Number
        }
    },
    {
        name: "settings",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: [{
                name: "centerPadding",
                mapping: {
                    type: PropertyMappingType.String
                }
            },
            {
                name: "slidesToShow",
                mapping: {
                    type: PropertyMappingType.Object,
                    oneOf: CardColumnSizeOneOf,
                }
            }]
        }
    }]
}

export const CardSlideShowResponsiveDefault = [{
    breakpoint: 1440,
    settings: {
        centerPadding: '90px',
        slidesToShow: 3
    }
}, {
    breakpoint: 1024,
    settings: {
        centerPadding: '80px',
        slidesToShow: 2
    }
}, {
    breakpoint: 768,
    settings: {
        centerPadding: '70px',
        slidesToShow: 1
    }
}, {
    breakpoint: 480,
    settings: {
        centerPadding: '60px',
        slidesToShow: 1
    }
}]


export const PostGalleryFullDefinitions: PropertyDefinition[] = [
    {
        name: "title",
        text: "Başlık",
        mapping: {
            type: PropertyMappingType.String
        }
    },
    {
        name: "type",
        text: "Dosya Tipi",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: [
                {
                    key: "image",
                    text: "Görsel"
                },
                {
                    key: "video",
                    text: "Video"
                }
            ],
        },
        default: "image"
    },
    {
        name: "src",
        text: "Dosya (Video - Fotoğraf)",
        mapping: {
            type: PropertyMappingType.File
        }
    },
    {
        name: "thumbnail",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ImageChildrenDefinitions,
        },
        description: "Slider Thumbs",
    },
    {
        name: "seeText",
        mapping: {
            type: PropertyMappingType.String,
        },
        description: "Slider Thumbs Full Gör Yazısı",
    },
];

export const ColumnReordersChildrenDefinition: PropertyDefinition[] = [
    {
        name: "lg",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: ReorderingOneOf,
        },
        text: "Masaüstü Görünümü",
    },
    {
        name: "md",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: ReorderingOneOf,
        },
        text: "Tablet Görünümü",
    },
    {
        name: "sm",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: ReorderingOneOf,
        },
        text: "Küçük Tablet Görünümü",
    },
    {
        name: "xs",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: ReorderingOneOf,
        },
        text: "Mobil Yan Görünüm",
    },
    {
        name: "xl",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: ReorderingOneOf,
        },
        text: "Mobil Görünümü",
    },
];

export const ColumnReordersDefinition: PropertyDefinition[] = [
    {
        name: "reorders",
        text: "Sıralamalar",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ColumnReordersChildrenDefinition,
        },
        description: "Sutünların cihaz boyutlarına göre sıralamasını ayarla",
        group: {
            key: "column",
            title: "Sutün Ayarları",
            withObject: true,
        },
    },
];

export const VideoDefinition: PropertyDefinition[] = [
    {
        name: "title",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Başlık",
    },
    {
        name: "subtitle",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Alt Başlık",
    },
    {
        name: "category",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Video Kategorisi",
    },
    {
        name: "description",
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        text: "Video Açıklaması",
    },
    {
        name: "datetime",
        text: "Tarih",
        description: "Video tarihi",
        mapping: {
            type: PropertyMappingType.DateTime,
        }
    },
    {
        name: "poster",
        mapping: {
            type: PropertyMappingType.Image,
        },
        initialFlowValue: true,
        text: "Video Poster Görseli Seçin",
    },
    {
        name: "formats",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: [
                {
                    name: "mp4",
                    mapping: {
                        type: PropertyMappingType.Video,
                    },
                },
                {
                    name: "ogg",
                    mapping: {
                        type: PropertyMappingType.Video,
                    },
                },
                {
                    name: "webm",
                    mapping: {
                        type: PropertyMappingType.Video,
                    },
                },
            ],
        },
        description: "Video Kaynakları",
        default: { mp4: "", ogg: "", webm: "" },
    },
    {
        name: "height",
        mapping: {
            type: PropertyMappingType.Number,
        },
        text: "Video Yüksekliği",
    },
    {
        name: "controls",
        mapping: {
            type: PropertyMappingType.Boolean,
        },
        text: "Oynat Düğmesini Gizle",
        default: true,
    },
    {
        name: "playsInline",
        mapping: {
            type: PropertyMappingType.Boolean,
        },
        text: "Satır İçi Oynat",
    },
    {
        name: "autoPlay",
        mapping: {
            type: PropertyMappingType.Boolean,
        },
        text: "Otomatik Oynat",
    },
    {
        name: "muted",
        mapping: {
            type: PropertyMappingType.Boolean,
        },
        text: "Sessiz Oynat",
    },
    {
        name: "loop",
        mapping: {
            type: PropertyMappingType.Boolean,
        },
        text: "Bitince Tekrar Et",
    },
    {
        name: "filter",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Özel Filtre",
    },
];

export const ImageSizeDefinition: PropertyDefinition[] = [
    {
        name: "imageSize",
        text: "Kırpma Maske Boyutu",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: ImageSizesOneOf,
        },
        default: "md",
        description: "Görsellerin liste üzerinde kırpılacağı boyutu ayarlayın.",
    },
];

export const ColumnSizes: PropertyDefinition[] = [
    {
        name: "xl",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: ColumnSizesOneOf,
        },
        text: "Masaüstü Görünümü",
    },
    {
        name: "lg",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: ColumnSizesOneOf,
        },
        text: "Büyük Tablet Görünümü",
    },
    {
        name: "md",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: ColumnSizesOneOf,
        },
        text: "Küçük Tablet Görünümü",
    },
    {
        name: "sm",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: ColumnSizesOneOf,
        },
        text: "Mobil Yan Görünüm",
    },
    {
        name: "xs",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: ColumnSizesOneOf,
        },
        text: "Mobil Görünümü",
    },
];

export const ColumnPropertyDefinitions: PropertyDefinition[] = [
    {
        name: "sizes",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ColumnSizes,
        },
        text: "Boyutlar",
        description: "Sutün boyutlarını tüm cihaz boyutlarına göre yapılandırır.",
        default: { lg: "", xs: "", sm: "", md: "", xl: "" },
    },
    {
        name: "reorders",
        text: "Sıralamalar",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ColumnReordersChildrenDefinition,
        },
        description: "Sutünların cihaz boyutlarına göre sıralamasını ayarla",
    },
    {
        name: "offsets",
        text: "Boşluklar",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ColumnSizes,
        },
        description: "Sutünların cihaz boyutlarına alacağı boşlukları yapılandırır",
    },
];

export const ProductPropertyDefinitions: PropertyDefinition[] = [
    {
        mapping: {
            type: PropertyMappingType.String,
        },
        name: "id",
        text: "Ürün ID",
    },
    {
        mapping: {
            type: PropertyMappingType.String,
        },
        name: "title",
        text: "Başlık",
    },
    {
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        name: "summary",
        text: "Kısa Açıklama",
    },
    {
        name: "image",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ImageChildrenDefinitions,
        },
        text: "Ürün Görseli",
    },
    {
        name: "contributor",
        mapping: {
            type: PropertyMappingType.Contributor,
        },
        text: "Eser Katılımcı / Katılımcıları",
    },
    {
        name: "pricing",
        mapping: {
            type: PropertyMappingType.Pricing,
        },
        text: "Ürün Fiyatlandırması",
    },
    {
        name: "label",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: [
                {
                    key: "",
                    text: "Tanım Yok",
                },
                {
                    key: "new",
                    text: "Yeni Ürün",
                },
                {
                    key: "best-selling",
                    text: "Çok Satan",
                },
            ],
        },
        text: "Ürün Tanımı",
    },
    {
        name: "anchor",
        mapping: {
            type: PropertyMappingType.LinkWizard,
        },
        text: "Ürün URL",
        default: null,
    },
];

export const ThemePropertyDefinitions: PropertyDefinition[] = [
    {
        mapping: {
            type: PropertyMappingType.String,
        },
        name: "title",
        text: "Başlık",
    },
    {
        name: "anchor",
        mapping: {
            type: PropertyMappingType.LinkWizard,
        },
        text: "Ürün URL",
        default: null,
    },
    {
        name: "image",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ImageChildrenDefinitions,
        },
        text: "Ürün Görseli",
    },
];

export const CardPropertyDefinitions: PropertyDefinition[] = [
    {
        mapping: {
            type: PropertyMappingType.String,
        },
        name: "title",
        text: "Başlık",
    },
    {
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        name: "description",
        text: "Açıklama",
    },
    {
        mapping: {
            type: PropertyMappingType.String,
        },
        name: "subtitle",
        text: "Alt Başlık Ör:(Opera Binası, Müzikal)",
    },
    {
        mapping: {
            type: PropertyMappingType.DateTime,
        },
        name: "datetime",
        text: "Tarih Bilgisi",
    },
    {
        mapping: {
            type: PropertyMappingType.String,
        },
        name: "fullName",
        text: "İsim Soyisim",
    },
    {
        name: "anchor",
        mapping: {
            type: PropertyMappingType.LinkWizard,
        },
        description: "Kart Url ",
        default: null,
    },
    {
        name: "image",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ImageChildrenDefinitions,
        },
        description: "Kart Resimleri",
    },
    {
        mapping: {
            type: PropertyMappingType.Boolean,
        },
        name: "disabled",
        text: "Pasif Hale Getirilsin Mi?",
    },
    {
        name: "isMoreButton",
        mapping: {
            type: PropertyMappingType.Boolean
        },
        description: "Daha Fazlası Butonu Gözüksün Mü?",
    },
    {
        name: "appearance",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: [
                {
                    key: '',
                    text: 'Varsayılan'
                },
                {
                    key: 'bordered',
                    text: 'Kenarlıklı'
                },
                {
                    key: 'rounded',
                    text: 'Yuvarlak'
                },
                {
                    key: 'center',
                    text: 'Ortala'
                },
                {
                    key: 'social-media',
                    text: 'Sosyal Medya Görünümü'
                },
                {
                    key: 'digital-scene',
                    text: 'Dijital Perde Görünümü'
                },
                {
                    key: 'video',
                    text: 'Video Görünümü'
                }
            ]
        },
        description: "Görünüm Tipleri",
    },
    {
        name: "counts",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: [
                {
                    name: "view",
                    mapping: {
                        type: PropertyMappingType.Number,
                    },
                },
                {
                    name: "like",
                    mapping: {
                        type: PropertyMappingType.Number,
                    },
                },
                {
                    name: "comment",
                    mapping: {
                        type: PropertyMappingType.Number,
                    },
                },
            ],
        },
        description: "Kart Görüntülenme Sayıları vs.",
    },
];

export const CorporationPropertyDefinitions: PropertyDefinition[] = [
    {
        name: "anchor",
        mapping: {
            type: PropertyMappingType.LinkWizard,
        },
        description: "Kart Url ",
        default: null,
    },
    {
        name: "image",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ImageChildrenDefinitions,
        },
        description: "Kurumsal kart resmi",
    },
    {
        name: "title",
        mapping: {
            type: PropertyMappingType.String,
        },
        description: "Kurumsal bağlantı başlığı",
    },
];

export const SubscribePropertyDefinitions: PropertyDefinition[] = [
    {
        name: "backdropFirst",
        mapping: {
            type: PropertyMappingType.Image,
        },
        description: "Arkaplan görseli",
    },
    {
        name: "backdropSecond",
        mapping: {
            type: PropertyMappingType.Image,
        },
        description: "Arkaplan görseli",
    },
    {
        name: "isFooter",
        mapping: {
            type: PropertyMappingType.Boolean,
        },
        description: "Footer Subscribe Tipi",
    }
];

export const ColumnOffsetsDefinition: PropertyDefinition[] = [
    {
        name: "offsets",
        text: "Boşluklar",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ColumnSizes,
        },
        description: "Sutünların cihaz boyutlarına alacağı boşlukları yapılandırır",
        group: {
            key: "column",
            title: "Sutün Ayarları",
            withObject: true,
        },
    },
];

export const ColumnSettingsDefinition: PropertyDefinition[] = [
    {
        name: "sizes",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ColumnSizes,
        },
        text: "Boyutlar",
        description: "Sutün boyutlarını tüm cihaz boyutlarına göre yapılandırır.",
        group: {
            key: "column",
            title: "Sutün Ayarları",
            withObject: true,
        },
        default: CardListSizesDefault,
    },
    ...ColumnOffsetsDefinition,
    ...ColumnReordersDefinition,
];

export const SlideshowDefinition: PropertyDefinition[] = [
    {
        name: "arrows",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: SlideshowArrows,
        },
        default: "ontop",
        text: "Slayt Okları",
    },
    {
        name: "lazyload",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: SlideshowLazyload,
        },
        default: "ondemand",
        text: "Lazyload",
    },
    {
        name: "slidesToShow",
        mapping: {
            type: PropertyMappingType.Number
        },
        text: "Gösterim Adedi"
    },
];

export const ImageCardDefinition: PropertyDefinition[] = [
    {
        name: "title",
        mapping: {
            type: PropertyMappingType.String,
        },
        default: "",
        text: "Başlık",
    },
    {
        name: "image",
        mapping: {
            type: PropertyMappingType.Image,
        },
        default: "",
        text: "Resim",
    },
    {
        name: "anchor",
        mapping: {
            type: PropertyMappingType.LinkWizard,
        },
        default: "",
        text: "Resim Link",
    },
];

export const HeroPropertyDefinitions: PropertyDefinition[] = [
    {
        mapping: {
            type: PropertyMappingType.Boolean,
        },
        name: "isCapitalize",
        text: "İlk harfi büyük olarak kullanılsın mı?",
    },
    {
        name: "anchor",
        description: "Kart Url ",
        mapping: {
            type: PropertyMappingType.LinkWizard,
        },
        default: null,
    },
    {
        name: "title",
        text: "Başlık",
        mapping: {
            type: PropertyMappingType.String,
        }
    },
    {
        name: "subTitle",
        text: "Alt Başlık",
        description: "Alt başlığı temsil eder",
        mapping: {
            type: PropertyMappingType.String,
        }
    },
    {
        name: "description",
        text: "Açıklama",
        description: "Açıklamayı temsil eder",
        mapping: {
            type: PropertyMappingType.String,
        }
    },
    {
        name: "datetime",
        text: "Tarih",
        description: "Banner tarihi",
        mapping: {
            type: PropertyMappingType.DateTime,
        }
    },
    {
        name: "image",
        text: "Arkaplan Resmi",
        description: "Arkaplanda gözükecek resimi temsil eder",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ImageChildrenDefinitions,
        }
    },
    {
        name: "mobileImage",
        text: "Mobile Arkaplan Resmi",
        description: "Mobile Arkaplanda gözükecek resimi temsil eder",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ImageChildrenDefinitions,
        }
    },
    {
        name: "video",
        text: "Arkaplan Video",
        description: "Arkaplanda gözükecek videoyu temsil eder",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: VideoChildrenDefinitions,
        }
    },
    {
        name: "secondaryImageName",
        text: "İkinci Arkaplan Resim Adı",
        description: "Arkaplanda gözükecek ikinci resimi göstermek için düğmede kullanılır",
        mapping: {
            type: PropertyMappingType.String,
        }
    },
    {
        name: "secondaryImage",
        text: "İkinci Arkaplan Resmi",
        description: "Arkaplanda gözükecek ikinci resimi temsil eder",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ImageChildrenDefinitions,
        }
    },
    {
        name: "transparent",
        text: "Transparan Resim",
        description: "Arkaplanda gözükecek resim için görünüm stilini değiştirir",
        mapping: {
            type: PropertyMappingType.Boolean,
        }
    },
    {
        name: "hashtag",
        text: "Sosyal Medya Hashtag",
        description: "Sosyal medya hastagi belirleyebilirsiniz",
        mapping: {
            type: PropertyMappingType.String,
        }
    },
];

export const MembershipPropertyDefinitions: PropertyDefinition[] = [
    {
        name: "anchor",
        description: "Kart Url ",
        mapping: {
            type: PropertyMappingType.LinkWizard,
        },
        default: null,
    },
];

export const EventDetailPropertyDefinitions: PropertyDefinition[] = [
    {
        name: "title",
        text: "Başlık",
        mapping: {
            type: PropertyMappingType.String,
        }
    },
    {
        name: "category",
        text: "Kategori İsmi",
        description: "Etkinlik Türünü Belirtir",
        mapping: {
            type: PropertyMappingType.String,
        }
    },
    {
        name: "anchor",
        description: "Kart Url ",
        mapping: {
            type: PropertyMappingType.LinkWizard,
        },
        default: null,
    },
    {
        name: "image",
        description: "Kart Resimleri",
        mapping: {
            type: PropertyMappingType.ParentObject,
            children: ImageChildrenDefinitions,
        }
    },
    {
        name: "datetime",
        text: "Tarih",
        description: "Etkinlik Tarihini Belirtir",
        mapping: {
            type: PropertyMappingType.DateTime,
        }
    },
];

export const VenueDetailPropertyDefinitions: PropertyDefinition[] = [
    {
        name: "info",
        text: "Bilgilendirme",
        mapping: {
            type: PropertyMappingType.Html,
        }
    },
    {
        name: "entranceFee",
        text: "Giriş Ücreti",
        mapping: {
            type: PropertyMappingType.Html,
        }
    },

];

export const SocialPropertyDefinitions: PropertyDefinition[] = [
    {
        name: "preTitle",
        text: "Sosyal Medya alanı ön yazısı",
        mapping: {
            type: PropertyMappingType.String,
        },
    },
    {
        name: "socialTag",
        text: "Sosyal #Hastag yazısı",
        mapping: {
            type: PropertyMappingType.String,
        },
    },
    {
        name: "isSocialTag",
        text: "Sosyal #Hastag Pasif Hale Getirilsin Mi?",
        mapping: {
            type: PropertyMappingType.Boolean,
        },
    },
    {
        name: "isPreTitle",
        text: "Ön Yazı Pasif Hale Getirilsin Mi?",
        mapping: {
            type: PropertyMappingType.Boolean,
        },
    },
    {
        name: "appearance",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: [
                {
                    key: '',
                    text: 'Varsayılan'
                },
                {
                    key: 'vertical',
                    text: 'Dikey Görünüm'
                },
                {
                    key: 'horizontal',
                    text: 'Yatay Görünüm'
                }
            ]
        },
        description: "Sosyal Medya Görünüm Tipleri",
    },
    {
        name: "align",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: [
                {
                    key: '',
                    text: 'Varsayılan'
                },
                {
                    key: 'center',
                    text: "Dikey'de Merkeze Hizalı"
                },
                {
                    key: 'end',
                    text: "Dikey'de Sona Hizalı"
                }
            ]
        }
    }
]

export const CultureRoadPropertyDefinitions: PropertyDefinition[] = [
    {
        name: "facebook",
        text: "Facebook adresi",
        mapping: {
            type: PropertyMappingType.String,
        },
    },
    {
        name: "youtube",
        text: "Youtube adresi",
        mapping: {
            type: PropertyMappingType.String,
        },
    },
    {
        name: "instagram",
        text: "Instagram adresi",
        mapping: {
            type: PropertyMappingType.String,
        },
    },
    {
        name: "twitter",
        text: "Twitter adresi",
        mapping: {
            type: PropertyMappingType.String,
        },
    },
    {
        name: "cards",
        mapping: {
            type: PropertyMappingType.ArrayData,
            keys: [
                {
                    name: "title",
                    mapping: {
                        type: PropertyMappingType.String
                    },
                    text: "Başlık"
                },
                {
                    name: "markerPosition",
                    mapping: {
                        type: PropertyMappingType.String
                    },
                    text: "İşaretçi Konumu"
                },
                {
                    name: "poster",
                    mapping: {
                        type: PropertyMappingType.ParentObject,
                        children: ImageChildrenDefinitions,
                    },
                    text: "Mekan Resmi Thumb"
                },
                {
                    name: "description",
                    text: "İçerik Açıklaması",
                    mapping: {
                        type: PropertyMappingType.Html
                    }
                },
                {
                    name: "googleAddress",
                    text: "Google Adres",
                    mapping: {
                        type: PropertyMappingType.String
                    }
                },
            ]
        },
        description: "Harita kart bilgileri",
    },
]

export const PageTitlePropertyDefinitions: PropertyDefinition[] = [
    {
        name: "breadcrumbs",
        mapping: {
            type: PropertyMappingType.ArrayData,
            keys: [{
                name: "anchor",
                text: "URL",
                mapping: {
                    type: PropertyMappingType.LinkWizard,
                }
            }]
        },
        description: "Harita kart bilgileri",
    },
    {
        mapping: {
            type: PropertyMappingType.String,
        },
        name: "title",
        text: "Başlık",
    },
    {
        mapping: {
            type: PropertyMappingType.String,
        },
        name: "category",
        text: "Kategori İsmi",
        description: "Ör: 'Opera Binası, Bale'",
    },
    {
        mapping: {
            type: PropertyMappingType.DateTime,
        },
        name: "datetime",
        text: "Tarih",
    },
    {
        mapping: {
            type: PropertyMappingType.Boolean,
        },
        name: "isSocial",
        text: "Sosyal Medya Görünsünmü",
    },
    {
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: [
                {
                    key: 'start',
                    text: "Baştan hizala",
                },
                {
                    key: 'center',
                    text: "Merkeze hizala",
                },
                {
                    key: 'end',
                    text: "Sona hizala",
                }
            ],
        },
        name: "socialAlign",
        text: "Sosyal Medya Hizalaması",
    },
    {
        mapping: {
            type: PropertyMappingType.String,
        },
        name: "socialPreTitle",
        text: "Sosyal Medya Ön Yazısı",
        description: "Örnek olarak 'Paylaş', 'Etkinliği Paylaş'"
    },
    {
        name: "appearance",
        mapping: {
            type: PropertyMappingType.Object,
            oneOf: [
                {
                    key: '',
                    text: 'Varsayılan'
                },
                {
                    key: 'gallery',
                    text: 'Galeri Tipi'
                }
            ]
        },
        description: "Görünüm Tipleri",
    },
];

